import { BrowserRouter } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { AppRoutes } from './router'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <Helmet>
        <title>Elkostart — Реклама, дизайн и фотосъемка</title>
        <meta
          name="description"
          content="Elkostart помогает бизнесу с металлоконструкциями, рекламой, дизайном и фотосъемкой. Комплексные решения «под ключ»."
        />
        <meta property="og:title" content="Elkostart — решения для бизнеса" />
        <meta
          property="og:description"
          content="Реклама, дизайн, металлоконструкции и фотосъемка для компаний. Погружаемся в задачи, работаем как партнеры."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elkostart.ru/" />
        <meta property="og:image" content="https://elkostart.ru/assets/hero-bg-SgPztalc.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Elkostart — решения для бизнеса" />
        <meta
          name="twitter:description"
          content="Комплексная реклама, дизайн и фотосъемка. Работаем рядом с вашей командой."
        />
        <meta name="twitter:image" content="https://elkostart.ru/assets/hero-bg-SgPztalc.jpg" />
      </Helmet>
      <AppRoutes />
    </BrowserRouter>
  )
}

export default App